import React from 'react'
import HeroBanner from '../components/Products/HeroBanner'
// import { Link } from 'react-router'
import Catalogue from '../components/Products/Catalogue'
import Cta from '../components/Products/Cta'
import CmsPageHero from '../components/CmsPageHero'

const ContactUs = () => {
    return (
        <>
            <CmsPageHero slug="products"><HeroBanner /></CmsPageHero>
            <Catalogue />
            <Cta />
        </>
    )
}

export default ContactUs
